
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34731',
  depVersions: {
  "documents-public-ui": "static-1.34731",
  "atom": "static-1.5166",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2588",
  "client-types": "static-1.479",
  "cssUtils": "static-1.817",
  "customer-data-filters-ui": "static-1.40100",
  "customer-data-objects": "static-1.7769",
  "customer-data-property-utils": "static-1.8187",
  "documents-lib": "static-1.34736",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.343",
  "FormsCommonComponents": "static-1.86103",
  "FormUrlGenerator": "static-2.4812",
  "foundations-theming-specialty": "static-1.2239",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5682",
  "hs-test-utils": "static-1.8109",
  "hub-http": "static-1.6312",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11872",
  "HubStyleTokens": "static-2.11565",
  "I18n": "static-7.1634",
  "icons": "static-2.651",
  "jasmine-immutable": "static-1.3112",
  "jasmine-runner": "static-1.6552",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7246",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5487",
  "quartz": "static-1.7141",
  "react": "static-7.187",
  "react-dlb": "static-1.80",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16772",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5411",
  "react-virtualized": "static-2.100",
  "reference-resolvers": "static-1.8265",
  "reference-resolvers-lite": "static-1.8189",
  "reporting-data": "static-1.67907",
  "reporting-reports": "static-1.67585",
  "reporting-snowflake": "static-1.56525",
  "reporting-testing-lib": "static-1.9840",
  "reporting-visualizations": "static-1.59983",
  "reselect": "static-2.16",
  "sales-content-partitioning": "static-1.9036",
  "sanitize": "static-1.4568",
  "sanitize-text": "static-1.8236",
  "self-service-api": "static-1.10339",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1836",
  "signup-constants": "static-1.19046",
  "signup-ui-url-generator": "static-2.8147",
  "StyleGuideUI": "static-3.488",
  "superstore": "static-1.4851",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4853",
  "ui-addon-form-validation": "static-1.11080",
  "ui-asset-management-lib": "static-1.11150",
  "ui-images": "static-2.1175",
  "UIComponents": "static-3.8511",
  "usage-tracker": "static-1.7439",
  "usage-tracker-container": "static-1.7429",
  "usage-tracker-core": "static-1.7289",
  "viral-links-lib": "static-1.7159",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9753",
  "foundations-components": "static-1.8106",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.919",
  "quartz-core": "static-1.6360",
  "quick-fetch": "static-1.3985",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4746",
  "ui-addon-i18n": "static-1.11242",
  "ui-addon-upgrades": "static-9.18121",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3468",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3418",
  "quartz-webpack": "static-1.3365",
  "foundations-assets": "static-1.4960",
  "foundations-theming": "static-1.4523",
  "hub-http-shared-msw-handlers": "static-1.10181",
  "hubspotter-http": "static-1.4719",
  "sassPrefix": "static-1.157",
  "conversations-skeleton-state": "static-1.7341",
  "crm-message-bus": "static-1.43214",
  "customer-data-filters-ui-msw-helpers": "static-1.22535",
  "customer-data-objects-ui-components": "static-1.13122",
  "customer-data-reference-ui-components": "static-1.13261",
  "customer-data-ui-utilities": "static-1.9917",
  "events-data-lib": "static-1.321",
  "framework-builder-read-service-client": "static-1.4073",
  "framework-data-schema-quick-fetch": "static-1.6885",
  "framework-data-schema-resolvers": "static-1.6980",
  "inbound-db-meta-service-client": "static-1.3654",
  "inbound-db-properties-service-client": "static-1.3913",
  "multi-account-reference-resolvers": "static-1.1073",
  "onboarding-tours": "static-1.16766",
  "reporting-datasets-permissions-lib": "static-1.13935",
  "ui-addon-teams": "static-1.21670",
  "quartz-auth": "static-1.816",
  "ui-business-units-lib": "static-1.9152",
  "usage-tracker-session-replay": "static-1.5125",
  "ai-components-ui-library": "static-1.9178",
  "ContentUtils": "static-1.68612",
  "customer-data-properties": "static-1.51894",
  "forms-ai-lib": "static-1.4457",
  "forms-utils-lib": "static-1.12747",
  "foundations-components-test-utils": "static-1.5589",
  "react-dnd-compat": "static-1.4705",
  "react-tinymce": "static-1.55480",
  "tinymce-config": "static-2.54606",
  "ui-gdpr-components": "static-1.10442",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3508",
  "HeadJS": "static-2.766",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3220",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "hs-locale-management": "static-1.149",
  "ui-fonts": "static-1.827",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4417",
  "csstype": "static-1.50",
  "quartz-head": "static-1.806",
  "web-vitals": "static-1.7",
  "batch-promise": "static-1.1633",
  "external-options-client-types": "static-1.4199",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.816",
  "frontend-preferences-client": "static-1.8017",
  "graphql": "static-1.83",
  "immer": "static-1.33",
  "persist-promise": "static-1.3790",
  "reporting-client-types": "static-1.2561",
  "apollo-stack-hubspot": "static-3.87",
  "growth-payments-core": "static-1.25642",
  "hubspot-apollo-client": "static-1.4969",
  "foundations-components-legacy": "static-1.1131",
  "merchandise-lib": "static-1.265",
  "quartz-routing": "static-1.571",
  "hs-story-utils": "static-1.9513",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.316",
  "timezone-utils": "static-2.5335",
  "seat-types-lib": "static-1.221",
  "react-create-root-preference": "static-1.32",
  "bend-plugin-foundations-components": "static-1.4375",
  "floating-ui": "static-1.57",
  "react-aria": "static-1.67",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2160",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.841",
  "mobile-manifest-mixins": "static-1.540",
  "module-federation": "static-1.24",
  "quartz-test": "static-1.816",
  "quartz-tracking": "static-1.520",
  "trellis-components": "static-1.2179",
  "bend-plugin-chirp-manifest": "static-1.156",
  "chirp-fetch": "static-1.1978",
  "purchase-motions-components": "static-1.6056",
  "salesImages": "static-1.526",
  "ts-schema": "static-1.4148",
  "bender-build-tools": "static-1.3278",
  "bend-plugin-foundations-theming": "static-1.3006",
  "stylex": "static-1.34",
  "restore-request-side-panel-lib": "static-1.1099",
  "react-immutable-render-mixin": "static-1.9",
  "hs-resources": "static-1.266",
  "pulse": "static-1.687",
  "conditional-properties-service-client": "static-1.3865",
  "crm-pipelines-api-client-types": "static-1.4206",
  "fdsr-migration-layer": "static-1.99",
  "multi-currency-client-types": "static-1.3758",
  "getting-started-shared-tasks": "static-1.18659",
  "growth-data-modal": "static-1.5569",
  "growth-onboarding-confetti": "static-1.3157",
  "growth-onboarding-next-action-utils": "static-1.2182",
  "navigation-components": "static-1.18240",
  "onboarding-tours-client": "static-1.4980",
  "onboarding-tours-utils": "static-1.832",
  "ui-shepherd-react": "static-3.10313",
  "ui-shepherd-tracker": "static-1.7694",
  "ui-universal-auth": "static-1.9084",
  "user-context": "static-1.5201",
  "hubspotter-http-shared-msw-handlers": "static-1.10179",
  "magpie-lib": "static-1.5610",
  "navigation-messaging": "static-1.7567",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.21724",
  "copilot-toolkit": "static-1.11361",
  "cms-field-types": "static-1.4904",
  "content-icons-ui": "static-1.2251",
  "integrations-lib": "static-1.16446",
  "calling-global-api": "static-1.64822",
  "calling-internal-common": "static-1.31401",
  "calling-lifecycle-internal": "static-1.66204",
  "calling-lifecycle-messages": "static-1.58498",
  "commerce-products-lib": "static-1.9871",
  "crm-links": "static-1.6397",
  "customer-data-properties-shared-msw-handlers": "static-1.9508",
  "file-manager-components": "static-1.23845",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4289",
  "meetings-icalendar-utils-lib": "static-1.724",
  "object-builder-ui-client": "static-1.49054",
  "pipeline-validation-client-types": "static-1.4034",
  "property-value-citations": "static-1.2508",
  "smart-property-lib": "static-1.7632",
  "tiered-pricing": "static-1.1415",
  "zustand": "static-1.74",
  "ui-addon-iframeable": "static-1.9153",
  "final-form": "static-1.71",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19979",
  "tinymce-themes": "static-1.56576",
  "data-token-picker": "static-1.16560",
  "hub-http-contrib": "static-1.3133",
  "interframe": "static-3.4851",
  "tinymce-data": "static-1.40691",
  "tinymce-plugins": "static-1.57720",
  "ui-addon-sales-email": "static-1.5301",
  "onboarding-scopes": "static-1.6553",
  "ui-addon-opt": "static-4.8451",
  "apollo-link-hub-http": "static-2.4744",
  "hubspot-apollo-cache": "static-1.428",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.263",
  "base-ui": "static-1.12",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1030",
  "tanstack-virtual": "static-1.31",
  "purchase-motions-api": "static-1.6059",
  "event-emitter": "static-1.1040",
  "bend-plugin-pulse": "static-1.190",
  "fast-json-patch": "static-1.64",
  "onboarding-data-sync-lib": "static-1.2113",
  "growth-onboarding-next-action-components": "static-1.2210",
  "user-context-client": "static-1.4678",
  "idb-keyval": "static-1.45",
  "magpie-types": "static-1.5070",
  "nest": "static-1.322",
  "reactive-lib": "static-1.817",
  "simple-logging-lib": "static-1.3142",
  "unified-auth-core-lib": "static-1.880",
  "getting-started-shared-tasks-store": "static-1.17777",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1011",
  "integrations-error-boundary-lib": "static-1.13861",
  "integrations-tracking-lib": "static-1.5697",
  "native-integrations-shared-strings": "static-1.7873",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10454",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.598",
  "calling-error-reporting": "static-1.31408",
  "shared-worker-versioning": "static-1.11126",
  "calling-usage-tracker": "static-1.6634",
  "voice-sms-access-library": "static-1.1340",
  "customer-data-tracking": "static-1.6981",
  "commerce-permissions": "static-1.868",
  "products-iframe-lib": "static-1.8170",
  "products-ui-components-shared-msw-handlers": "static-1.10563",
  "location-customization-utils-lib": "static-1.9521",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4245",
  "video-components-external": "static-1.11567",
  "video-data-lib": "static-1.35225",
  "data-agent-kit": "static-1.336",
  "feedback-loader": "static-1.29459",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10264",
  "fsm": "static-1.3820",
  "policy-lib": "static-1.6871",
  "react-colorpicker": "static-2.10299",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10327",
  "FileManagerLib": "static-1.39485",
  "NamespacedHubStyle": "static-2.9126",
  "FileManagerCore": "static-1.39344",
  "codemirror": "static-5.96",
  "content-assistance-lib": "static-1.7892",
  "layout-dnd-components": "static-1.12611",
  "layout-dnd-utils": "static-1.11586",
  "react-codemirror": "static-1.10719",
  "ui-addon-emoji-picker": "static-1.9978",
  "ui-brand-identity-lib": "static-1.15595",
  "InboxConnectUtils": "static-4.15045",
  "meetings-connect-utils-lib": "static-1.7695",
  "breeze-engine-core": "static-1.289",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "universal-page-editor-lib": "static-1.3108",
  "ads-unified-auth-lib": "static-1.266",
  "google-sheets-integration-lib": "static-1.501",
  "microsoft-drive-integration-lib": "static-1.639",
  "slack-ui-library": "static-1.10484",
  "calling-orchestration-schema": "static-1.36117",
  "sales-views-client-types": "static-1.4348",
  "crm-record-cards-service-types": "static-1.3658",
  "content-media-composition-data-lib": "static-1.12601",
  "content-media-compositions": "static-2.16608",
  "media-bridge-lib": "static-1.19077",
  "trellis-story-utils": "static-1.4604",
  "storybook-react": "static-1.34",
  "audio-components": "static-1.6051",
  "FileManagerImages": "static-1.36996",
  "video-components": "static-1.13569",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4628",
  "video-embed": "static-1.36059",
  "diff-match-patch": "static-1.7",
  "ui-addon-video-player": "static-1.8794",
  "ui-coaching-tips": "static-1.28810",
  "ContentData": "static-1.68687",
  "layout-data-lib": "static-1.9911",
  "browser-eslint": "static-2.57",
  "social-insights-client-types": "static-1.22298",
  "outpost": "static-1.4262",
  "growth-onboarding-feedback-components": "static-1.6670",
  "advanced-menus-core": "static-1.15271",
  "advanced-menus-lib": "static-1.12188",
  "ExportDialog": "static-6.10472",
  "ui-memberships-settings-lib": "static-1.34287",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15270",
  "simple-menus-lib": "static-1.16787"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34731",
  "atom": "/atom/static-1.5166",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2588",
  "client-types": "/client-types/static-1.479",
  "cssUtils": "/cssUtils/static-1.817",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40100",
  "customer-data-objects": "/customer-data-objects/static-1.7769",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8187",
  "documents-lib": "/documents-lib/static-1.34736",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.343",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86103",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4812",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2239",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5682",
  "hs-test-utils": "/hs-test-utils/static-1.8109",
  "hub-http": "/hub-http/static-1.6312",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11872",
  "HubStyleTokens": "/HubStyleTokens/static-2.11565",
  "I18n": "/I18n/static-7.1634",
  "icons": "/icons/static-2.651",
  "jasmine-immutable": "/jasmine-immutable/static-1.3112",
  "jasmine-runner": "/jasmine-runner/static-1.6552",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7246",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5487",
  "quartz": "/quartz/static-1.7141",
  "react": "/react/static-7.187",
  "react-dlb": "/react-dlb/static-1.80",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16772",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5411",
  "react-virtualized": "/react-virtualized/static-2.100",
  "reference-resolvers": "/reference-resolvers/static-1.8265",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8189",
  "reporting-data": "/reporting-data/static-1.67907",
  "reporting-reports": "/reporting-reports/static-1.67585",
  "reporting-snowflake": "/reporting-snowflake/static-1.56525",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9840",
  "reporting-visualizations": "/reporting-visualizations/static-1.59983",
  "reselect": "/reselect/static-2.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9036",
  "sanitize": "/sanitize/static-1.4568",
  "sanitize-text": "/sanitize-text/static-1.8236",
  "self-service-api": "/self-service-api/static-1.10339",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1836",
  "signup-constants": "/signup-constants/static-1.19046",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8147",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "superstore": "/superstore/static-1.4851",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4853",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11080",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11150",
  "ui-images": "/ui-images/static-2.1175",
  "UIComponents": "/UIComponents/static-3.8511",
  "usage-tracker": "/usage-tracker/static-1.7439",
  "usage-tracker-container": "/usage-tracker-container/static-1.7429",
  "usage-tracker-core": "/usage-tracker-core/static-1.7289",
  "viral-links-lib": "/viral-links-lib/static-1.7159",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9753",
  "foundations-components": "/foundations-components/static-1.8106",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.919",
  "quartz-core": "/quartz-core/static-1.6360",
  "quick-fetch": "/quick-fetch/static-1.3985",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4746",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11242",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18121",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3468",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3418",
  "quartz-webpack": "/quartz-webpack/static-1.3365",
  "foundations-assets": "/foundations-assets/static-1.4960",
  "foundations-theming": "/foundations-theming/static-1.4523",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10181",
  "hubspotter-http": "/hubspotter-http/static-1.4719",
  "sassPrefix": "/sassPrefix/static-1.157",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7341",
  "crm-message-bus": "/crm-message-bus/static-1.43214",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22535",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13122",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13261",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9917",
  "events-data-lib": "/events-data-lib/static-1.321",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4073",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6885",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6980",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3654",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3913",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1073",
  "onboarding-tours": "/onboarding-tours/static-1.16766",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13935",
  "ui-addon-teams": "/ui-addon-teams/static-1.21670",
  "quartz-auth": "/quartz-auth/static-1.816",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9152",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5125",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9178",
  "ContentUtils": "/ContentUtils/static-1.68612",
  "customer-data-properties": "/customer-data-properties/static-1.51894",
  "forms-ai-lib": "/forms-ai-lib/static-1.4457",
  "forms-utils-lib": "/forms-utils-lib/static-1.12747",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5589",
  "react-dnd-compat": "/react-dnd-compat/static-1.4705",
  "react-tinymce": "/react-tinymce/static-1.55480",
  "tinymce-config": "/tinymce-config/static-2.54606",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10442",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3508",
  "HeadJS": "/HeadJS/static-2.766",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3220",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "hs-locale-management": "/hs-locale-management/static-1.149",
  "ui-fonts": "/ui-fonts/static-1.827",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4417",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.806",
  "web-vitals": "/web-vitals/static-1.7",
  "batch-promise": "/batch-promise/static-1.1633",
  "external-options-client-types": "/external-options-client-types/static-1.4199",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.816",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8017",
  "graphql": "/graphql/static-1.83",
  "immer": "/immer/static-1.33",
  "persist-promise": "/persist-promise/static-1.3790",
  "reporting-client-types": "/reporting-client-types/static-1.2561",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "growth-payments-core": "/growth-payments-core/static-1.25642",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4969",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1131",
  "merchandise-lib": "/merchandise-lib/static-1.265",
  "quartz-routing": "/quartz-routing/static-1.571",
  "hs-story-utils": "/hs-story-utils/static-1.9513",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.316",
  "timezone-utils": "/timezone-utils/static-2.5335",
  "seat-types-lib": "/seat-types-lib/static-1.221",
  "react-create-root-preference": "/react-create-root-preference/static-1.32",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4375",
  "floating-ui": "/floating-ui/static-1.57",
  "react-aria": "/react-aria/static-1.67",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2160",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.841",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.540",
  "module-federation": "/module-federation/static-1.24",
  "quartz-test": "/quartz-test/static-1.816",
  "quartz-tracking": "/quartz-tracking/static-1.520",
  "trellis-components": "/trellis-components/static-1.2179",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.156",
  "chirp-fetch": "/chirp-fetch/static-1.1978",
  "purchase-motions-components": "/purchase-motions-components/static-1.6056",
  "salesImages": "/salesImages/static-1.526",
  "ts-schema": "/ts-schema/static-1.4148",
  "bender-build-tools": "/bender-build-tools/static-1.3278",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3006",
  "stylex": "/stylex/static-1.34",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1099",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hs-resources": "/hs-resources/static-1.266",
  "pulse": "/pulse/static-1.687",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3865",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4206",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.99",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3758",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18659",
  "growth-data-modal": "/growth-data-modal/static-1.5569",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3157",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2182",
  "navigation-components": "/navigation-components/static-1.18240",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4980",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.832",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10313",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7694",
  "ui-universal-auth": "/ui-universal-auth/static-1.9084",
  "user-context": "/user-context/static-1.5201",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10179",
  "magpie-lib": "/magpie-lib/static-1.5610",
  "navigation-messaging": "/navigation-messaging/static-1.7567",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.21724",
  "copilot-toolkit": "/copilot-toolkit/static-1.11361",
  "cms-field-types": "/cms-field-types/static-1.4904",
  "content-icons-ui": "/content-icons-ui/static-1.2251",
  "integrations-lib": "/integrations-lib/static-1.16446",
  "calling-global-api": "/calling-global-api/static-1.64822",
  "calling-internal-common": "/calling-internal-common/static-1.31401",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66204",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58498",
  "commerce-products-lib": "/commerce-products-lib/static-1.9871",
  "crm-links": "/crm-links/static-1.6397",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9508",
  "file-manager-components": "/file-manager-components/static-1.23845",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4289",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.724",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49054",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4034",
  "property-value-citations": "/property-value-citations/static-1.2508",
  "smart-property-lib": "/smart-property-lib/static-1.7632",
  "tiered-pricing": "/tiered-pricing/static-1.1415",
  "zustand": "/zustand/static-1.74",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9153",
  "final-form": "/final-form/static-1.71",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19979",
  "tinymce-themes": "/tinymce-themes/static-1.56576",
  "data-token-picker": "/data-token-picker/static-1.16560",
  "hub-http-contrib": "/hub-http-contrib/static-1.3133",
  "interframe": "/interframe/static-3.4851",
  "tinymce-data": "/tinymce-data/static-1.40691",
  "tinymce-plugins": "/tinymce-plugins/static-1.57720",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5301",
  "onboarding-scopes": "/onboarding-scopes/static-1.6553",
  "ui-addon-opt": "/ui-addon-opt/static-4.8451",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4744",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.428",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.263",
  "base-ui": "/base-ui/static-1.12",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1030",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "purchase-motions-api": "/purchase-motions-api/static-1.6059",
  "event-emitter": "/event-emitter/static-1.1040",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.190",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2113",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2210",
  "user-context-client": "/user-context-client/static-1.4678",
  "idb-keyval": "/idb-keyval/static-1.45",
  "magpie-types": "/magpie-types/static-1.5070",
  "nest": "/nest/static-1.322",
  "reactive-lib": "/reactive-lib/static-1.817",
  "simple-logging-lib": "/simple-logging-lib/static-1.3142",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.880",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17777",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1011",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13861",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5697",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7873",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10454",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.598",
  "calling-error-reporting": "/calling-error-reporting/static-1.31408",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11126",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6634",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1340",
  "customer-data-tracking": "/customer-data-tracking/static-1.6981",
  "commerce-permissions": "/commerce-permissions/static-1.868",
  "products-iframe-lib": "/products-iframe-lib/static-1.8170",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10563",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9521",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4245",
  "video-components-external": "/video-components-external/static-1.11567",
  "video-data-lib": "/video-data-lib/static-1.35225",
  "data-agent-kit": "/data-agent-kit/static-1.336",
  "feedback-loader": "/feedback-loader/static-1.29459",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10264",
  "fsm": "/fsm/static-1.3820",
  "policy-lib": "/policy-lib/static-1.6871",
  "react-colorpicker": "/react-colorpicker/static-2.10299",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10327",
  "FileManagerLib": "/FileManagerLib/static-1.39485",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9126",
  "FileManagerCore": "/FileManagerCore/static-1.39344",
  "codemirror": "/codemirror/static-5.96",
  "content-assistance-lib": "/content-assistance-lib/static-1.7892",
  "layout-dnd-components": "/layout-dnd-components/static-1.12611",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11586",
  "react-codemirror": "/react-codemirror/static-1.10719",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9978",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15595",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15045",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7695",
  "breeze-engine-core": "/breeze-engine-core/static-1.289",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3108",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.266",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.501",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.639",
  "slack-ui-library": "/slack-ui-library/static-1.10484",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36117",
  "sales-views-client-types": "/sales-views-client-types/static-1.4348",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3658",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12601",
  "content-media-compositions": "/content-media-compositions/static-2.16608",
  "media-bridge-lib": "/media-bridge-lib/static-1.19077",
  "trellis-story-utils": "/trellis-story-utils/static-1.4604",
  "storybook-react": "/storybook-react/static-1.34",
  "audio-components": "/audio-components/static-1.6051",
  "FileManagerImages": "/FileManagerImages/static-1.36996",
  "video-components": "/video-components/static-1.13569",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4628",
  "video-embed": "/video-embed/static-1.36059",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8794",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28810",
  "ContentData": "/ContentData/static-1.68687",
  "layout-data-lib": "/layout-data-lib/static-1.9911",
  "browser-eslint": "/browser-eslint/static-2.57",
  "social-insights-client-types": "/social-insights-client-types/static-1.22298",
  "outpost": "/outpost/static-1.4262",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6670",
  "advanced-menus-core": "/advanced-menus-core/static-1.15271",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12188",
  "ExportDialog": "/ExportDialog/static-6.10472",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34287",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15270",
  "simple-menus-lib": "/simple-menus-lib/static-1.16787"
}
};
